import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import PageShell from '@/components/site/PageShell';
import PageHero from '@/components/site/PageHero';
import About from '@/components/site/About';
import ClosingCTA from '@/components/site/ClosingCTA';

const COPY = {
  it: {
    eyebrow: 'Chi siamo',
    title_a: 'Costruito da chi visita,',
    title_b: 'non da chi vende software.',
    subtitle:
      'Ogni schermata, ogni shortcut, ogni automazione è nata dentro uno studio oculistico reale — guardando ricette stampate, agende cartacee e segretarie sommerse. Per questo Prime Vision non aggiunge processi: ne toglie. È il software che avresti voluto avere dieci anni fa, fatto per il tuo modo di visitare oggi.',
  },
  en: {
    eyebrow: 'About us',
    title_a: 'Built by people who examine patients,',
    title_b: 'not by people who sell software.',
    subtitle:
      'Every screen, every shortcut, every automation was born inside a real eye-care practice — looking at printed prescriptions, paper diaries and front-desks underwater. That\'s why Prime Vision doesn\'t add processes: it removes them. It\'s the software you wish you had ten years ago, designed for the way you examine patients today.',
  },
};

export const AboutPage = () => {
  const { locale } = useLanguage();
  const c = COPY[locale] || COPY.it;

  return (
    <PageShell title={c.eyebrow} testId="pv-about-page">
      <PageHero
        eyebrow={c.eyebrow}
        title_a={c.title_a}
        title_b={c.title_b}
        subtitle={c.subtitle}
        ctas={['demo', 'brochure', 'whatsapp']}
        source="about-hero"
        testId="pv-about-page-hero"
      />
      <About compact />
      <ClosingCTA source="about-closing" />
    </PageShell>
  );
};

export default AboutPage;
